
import { defineComponent } from 'vue';
import Module1 from '@/components/home/module1.vue';
import Module2 from '@/components/home/module2.vue';
// import Module3 from '@/components/home/module3.vue';
// import Module4 from '@/components/home/module4.vue';
// import Module5 from '@/components/home/module5.vue';
import Module6 from '@/components/home/module6.vue';
import About from '@/components/home/about.vue';

export default defineComponent({
    name: 'Home',
    components: {
        Module1,
        Module2,
        // Module3,
        // Module4,
        // Module5,
        Module6,
        About
    }
});
